/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Coin, CoinInterface } from "../Coin";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "string",
        name: "_name",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromDelegate",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toDelegate",
        type: "address",
      },
    ],
    name: "DelegateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "delegate",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "previousBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBalance",
        type: "uint256",
      },
    ],
    name: "DelegateVotesChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "transferable",
        type: "bool",
      },
    ],
    name: "RestrictedTransferUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "pos",
        type: "uint32",
      },
    ],
    name: "checkpoints",
    outputs: [
      {
        components: [
          {
            internalType: "uint32",
            name: "fromBlock",
            type: "uint32",
          },
          {
            internalType: "uint224",
            name: "votes",
            type: "uint224",
          },
        ],
        internalType: "struct ERC20Votes.Checkpoint",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
    ],
    name: "delegate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "delegatee",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "delegateBySig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "delegates",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastTotalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "blockNumber",
        type: "uint256",
      },
    ],
    name: "getPastVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "getVotes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "numCheckpoints",
    outputs: [
      {
        internalType: "uint32",
        name: "",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_URI",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_restrictedTransfer",
        type: "bool",
      },
    ],
    name: "setRestrictedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "transfersRestricted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type CoinConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: CoinConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Coin__factory extends ContractFactory {
  constructor(...args: CoinConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _name: string,
    _symbol: string,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Coin> {
    return super.deploy(
      _controlCenter,
      _name,
      _symbol,
      _trustedForwarder,
      _uri,
      overrides || {}
    ) as Promise<Coin>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _name: string,
    _symbol: string,
    _trustedForwarder: string,
    _uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _name,
      _symbol,
      _trustedForwarder,
      _uri,
      overrides || {}
    );
  }
  attach(address: string): Coin {
    return super.attach(address) as Coin;
  }
  connect(signer: Signer): Coin__factory {
    return super.connect(signer) as Coin__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): CoinInterface {
    return new utils.Interface(_abi) as CoinInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Coin {
    return new Contract(address, _abi, signerOrProvider) as Coin;
  }
}
